import { BellRing, Check, Clock3, LockKeyhole, RefreshCw, X } from 'lucide-react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { supabase } from '../lib/supabase'

type Request={id:string;table_number:number;created_at:string;status:string}
export function TableViewApprovals(){
 const [requests,setRequests]=useState<Request[]>([])
 const [error,setError]=useState('')
 const [busy,setBusy]=useState('')
 const [ready,setReady]=useState(false)
 const [sound,setSound]=useState(false)
 const seen=useRef(new Set<string>())
 const initialized=useRef(false)
 const load=useCallback(async()=>{
  const {data,error:issue}=await supabase.rpc('table_view_staff_requests')
  if(issue){setError('Não foi possível consultar permissões: '+issue.message);return}
  setError('')
  const entries=(Array.isArray(data)?data:[]) as Request[]
  if(initialized.current){
   const novel=entries.filter(r=>!seen.current.has(r.id))
   if(novel.length)setSound(true)
  }else initialized.current=true
  seen.current=new Set(entries.map(r=>r.id))
  setRequests(entries);setReady(true)
 },[])
 useEffect(()=>{void load();const timer=window.setInterval(()=>void load(),5000);return()=>window.clearInterval(timer)},[load])
 async function decide(id:string,approve:boolean){
  if(approve&&!window.confirm('Você confirmou pessoalmente que o cliente está na mesa? Liberar a visualização da comanda conjunta por 20 minutos?'))return
  setBusy(id);setError('')
  const {data,error:issue}=await supabase.rpc('table_view_staff_decide',{p_request_id:id,p_approve:approve})
  setBusy('')
  if(issue||data?.error){setError(data?.error||issue?.message||'Não foi possível responder.');return}
  await load()
 }
 return <section className={requests.length?'panel table-view-approvals has-pending':'panel table-view-approvals'}>
  <div className="panel-heading"><div><span className="eyebrow dark">PRIVACIDADE DAS MESAS</span><h3><LockKeyhole size={20}/> Autorizações para ver comandas</h3><small>O cliente só enxerga o consumo depois da sua aprovação.</small></div><button type="button" className="ghost-button" onClick={()=>{setSound(false);void load()}}><RefreshCw size={16}/> Atualizar</button></div>
  {error&&<p className="form-error" role="alert">{error}</p>}
  {!ready?<p>Consultando solicitações…</p>:requests.length?<div className="table-view-approval-list">
    {requests.map(item=><div key={item.id} className="table-view-approval">
     <div><BellRing size={20}/><div><strong>CLIENTE SOLICITOU · MESA {item.table_number}</strong><small>{new Date(item.created_at).toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'})} · Confira pessoalmente antes de liberar</small></div></div>
     <div className="table-view-approval-buttons"><button type="button" className="secondary-button" disabled={Boolean(busy)} onClick={()=>void decide(item.id,false)}><X size={16}/> Negar</button><button type="button" className="primary-button" disabled={Boolean(busy)} onClick={()=>void decide(item.id,true)}><Check size={16}/> Liberar acesso</button></div>
    </div>)}
   </div>:<div className="table-view-approval-empty"><Clock3 size={18}/> Nenhuma autorização pendente.</div>}
  {sound&&requests.length>0&&<p className="table-view-approval-tip">Há novas solicitações aguardando sua conferência.</p>}
  <small className="table-view-approval-note">Liberação temporária de 20 minutos, somente leitura. O acesso termina quando a mesa é encerrada ou reaberta.</small>
 </section>
}
